import jwtDecode from "jwt-decode";

export const set = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify(value))
  return get(key)
}

export const get = key => {
  let retorno = JSON.parse(sessionStorage.getItem(key))
  return retorno
}

export const getUser = () => {
  const token = sessionStorage.getItem('authSistema');
  if (!token) return undefined;
  
  try {
    const user = jwtDecode(token);
    return user;
  } catch (error) {
    console.error('Erro ao decodificar token:', error);
    return undefined;
  }
}

export const clear = key => {
  sessionStorage.clear()
  localStorage.removeItem('isAuthenticated')
}